import { getVideoPlayerManager } from './manager';
export var VIDEO_PLAYER_VIMEO = 'Vimeo';
export var VIDEO_PLAYER_WISTIA = 'Wistia';
export var EVENT_PLAYER_CREATED = 'PlayerCreated';
export var EVENT_PLAYER_LOADED = 'PlayerLoaded';
export var EVENT_PLAYER_PROGRESSED = 'PlayerProgressed';
export { getVideoPlayerManager };